import { Link } from 'react-router-dom';
import { Instagram, Music, Youtube, Twitter, Heart } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative mt-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-pink-500 via-purple-600 to-blue-500 flex items-center justify-center text-lg font-black">
                M
              </div>
              <span className="text-xl font-black">
                <span className="text-white">MUZI</span>{' '}
                <span className="text-gradient">BATTLE</span>
              </span>
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed max-w-xs">
              Chante. Joue. Deviens viral. L'app qui transforme ta voix et ton visage en magie.
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-3 text-sm">Produit</h4>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/studio" className="hover:text-pink-400 transition-colors">Studio IA</Link></li>
              <li><Link to="/battle" className="hover:text-pink-400 transition-colors">Battle</Link></li>
              <li><Link to="/live" className="hover:text-pink-400 transition-colors">Karaoké Live</Link></li>
              <li><Link to="/shop" className="hover:text-pink-400 transition-colors">Boutique</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-3 text-sm">Communauté</h4>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/fans" className="hover:text-pink-400 transition-colors">Fans & Stars</Link></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Classements</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Défis</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Créateurs</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-3 text-sm">Légal</h4>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><a href="#" className="hover:text-pink-400 transition-colors">Confidentialité</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Conditions</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Support</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-white/5">
          <p className="text-xs text-zinc-500 flex items-center gap-1.5">
            © 2025 MUZI BATTLE — Fait avec <Heart size={12} className="text-pink-500" /> pour la Gen Z
          </p>
          <div className="flex items-center gap-3">
            <a href="#" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-pink-500/20 hover:text-pink-400 text-zinc-400 flex items-center justify-center transition-colors" aria-label="Instagram"><Instagram size={16} /></a>
            <a href="#" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-pink-500/20 hover:text-pink-400 text-zinc-400 flex items-center justify-center transition-colors" aria-label="TikTok"><Music size={16} /></a>
            <a href="#" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-pink-500/20 hover:text-pink-400 text-zinc-400 flex items-center justify-center transition-colors" aria-label="YouTube"><Youtube size={16} /></a>
            <a href="#" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-pink-500/20 hover:text-pink-400 text-zinc-400 flex items-center justify-center transition-colors" aria-label="X"><Twitter size={16} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
